/** A candidate quantity is not necessarily a rendered row: exclusions can remove it. */
export function existingMatrixQuantityFeedback(input: {
  quantity: number;
  presetQuantities: readonly number[];
  customQuantities: readonly number[];
  rows: readonly { quantity: number }[];
  loading: boolean;
}): 'quantityAlreadyShown' | 'quantityStillLoading' | 'quantityNotAvailable' | null {
  if (!input.presetQuantities.includes(input.quantity) && !input.customQuantities.includes(input.quantity)) return null;
  if (input.rows.some(row => row.quantity === input.quantity)) return 'quantityAlreadyShown';
  return input.loading ? 'quantityStillLoading' : 'quantityNotAvailable';
}
